module.exports = __webpack_public_path__ + "img/step2-b.5060a567.png";